// extracted by css-extract-rspack-plugin
export default {"cls1":"data_scope-cls1_Gke","cls2":"data_scope-cls2_PW_ data_scope-cls1_Gke"};